import { render } from "./Incomes.vue?vue&type=template&id=8b84dcae&scoped=true"
import script from "./Incomes.vue?vue&type=script&lang=js"
export * from "./Incomes.vue?vue&type=script&lang=js"

import "./Incomes.vue?vue&type=style&index=0&id=8b84dcae&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b84dcae"]])

export default __exports__